module.exports = __webpack_public_path__ + "static/horus_05-a8c5fbc56169015dc1d0d7bede974731.jpg";